//@ts-nocheck

import CardNews from "../molecules/CardNews"
import CardDocuments from "../molecules/CardDocuments"
import CardUseCases from "../molecules/CardUseCases"
import CardCertifications from "../molecules/CardCertifications"
import CardExpertise from "../molecules/CardExpertise"

type CarouselCardsProps = {
  type?: string
  sectionId?: string
  colorScheme?: string
  preTitle?: string
  title?: string
  body?: string
  ctaPrimary?: {
    label?: string
    href?: string
  }
  cta?: {
    label?: string
    href?: string
  }
  items?: any[]
  news?: any[],
  documents?: any[]
  cases?: any[]
}

const CarouselCards = <CarouselCardsProps>({
  type,
  sectionId,
  colorScheme,
  preTitle,
  title,
  body,
  ctaPrimary,
  cta,
  items = [],
  news = [],
  documents = [],
  cases = [],
  ...rest
}) => {
  let itemsByType = []
  switch (type) {
    case 'CardExpertise':
      itemsByType = items.reduce((acc, item) => {
        const normalizedData = CardExpertise(item, colorScheme)
        return [...acc, normalizedData]
      }, [])
      break
    case 'CardSquare':
      itemsByType = items
      break
    case 'CardDocuments':
      itemsByType = documents.reduce((acc, item) => {
        const normalizedData = CardDocuments(item, colorScheme)
        return [...acc, normalizedData]
      }, [])
      break
    case 'CardNews':
      itemsByType = news.reduce((acc, item) => {
        const normalizedData = CardNews(item)
        return [...acc, normalizedData]
      }, [])
      break
    case 'CardCase':
      itemsByType = cases.reduce((acc, item) => {
        const normalizedData = CardUseCases(item)
        return [...acc, normalizedData]
      }, [])
      break
    case 'CardCertification':
      itemsByType = items.reduce((acc, item) => {
        const normalizedData = CardCertifications(item)
        return [...acc, normalizedData]
      }, [])
      break
    default:
      break
  }

  const normalizedData = {
    type,
    sectionId,
    colorScheme,
    preTitle,
    title,
    body,
    ctaPrimary,
    cta,
    items: itemsByType,
    ...rest
  }

  return normalizedData
}

export default CarouselCards
